import * as Sentry from '@sentry/react';

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.PROD,
    environment: import.meta.env.MODE,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance: 20% das transações
    tracesSampleRate: 0.2,

    // Session Replay: 10% normal, 100% em sessões com erro
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Filtrar erros de extensões do browser
    beforeSend(event) {
      if (event.exception?.values?.[0]?.stacktrace?.frames?.some(
        frame => frame.filename?.includes('chrome-extension://')
      )) {
        return null;
      }
      return event;
    },

    // Não capturar breadcrumbs de console (são muitos em produção)
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'console') {
        return null;
      }
      return breadcrumb;
    },
  });
}

/**
 * Setar contexto de usuário autenticado no Sentry.
 * Chamar quando o usuário loga ou quando org/role mudam.
 */
export function setSentryUser(user: {
  id: string;
  email?: string | null;
  orgId?: string;
  role?: string;
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email ?? undefined,
  });
  if (user.orgId) {
    Sentry.setTag('org_id', user.orgId);
  }
  if (user.role) {
    Sentry.setTag('user_role', user.role);
  }
}

/**
 * Limpar contexto de usuário no logout.
 */
export function clearSentryUser() {
  Sentry.setUser(null);
}
